import { useMemo } from 'react';

import professionRegionChangeButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/profession_region_change_button_click';
import { TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { createStaticDataProvider } from '@hh.ru/magritte-common-data-provider';
import { FormLabel, Segment, Segmented, Select, useBreakpoint, VSpacingContainer } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { PROFESSION_AREAS, professionAreaIdToAreaEnumMap } from 'src/fixtures/areas';
import useUserArea from 'src/hooks/useUserArea';
import { AreaEnum } from 'src/types/area';

const TrlKeys = {
    description: 'career-platform.profession.nav-regions.description',
    select: {
        label: 'career-platform.profession.nav-regions.select.label',
        headerTitle: 'career-platform.profession.nav-regions.select.header-title',
    },
};

const NavRegions: TranslatedComponent = ({ trls }) => {
    const { currentRegion } = useSelectorNonNullable((state) => state.pageProfession);
    const { area, onPushQueryArea } = useUserArea();
    const { isMobile } = useBreakpoint();

    const options = useMemo(() => {
        const options = PROFESSION_AREAS.map(({ id, text }) => ({
            value: id,
            text,
        }));

        if (options.some(({ value }) => value === area.id)) {
            return options;
        }

        return [{ text: area.text, value: area.id }, ...options];
    }, [area]);

    const handleChange = (value: string) => {
        professionRegionChangeButtonClick({
            buttonName: professionAreaIdToAreaEnumMap[value] || AreaEnum.LOCAL,
        });
        onPushQueryArea(value);
    };

    return (
        <VSpacingContainer default={12}>
            <FormLabel>{trls[TrlKeys.description]}</FormLabel>
            {isMobile && (
                <Select
                    type="label"
                    value={options.find((el) => el.value === currentRegion)}
                    name="selectRegion"
                    dataProvider={createStaticDataProvider(options)}
                    bottomSheetHeight="content"
                    plain={false}
                    headerTitle={trls[TrlKeys.select.headerTitle]}
                    triggerProps={{
                        label: trls[TrlKeys.select.label],
                        size: 'large',
                        elevateLabel: true,
                        stretched: true,
                    }}
                    onChange={(item) => handleChange(item.value)}
                />
            )}
            {!isMobile && (
                <Segmented
                    mode="label"
                    size="medium"
                    stretched
                    selectedValue={currentRegion}
                    onChange={(e) => handleChange(e.target.value)}
                >
                    {options.map((item) => (
                        <Segment value={item.value} key={item.value}>
                            {item.text}
                        </Segment>
                    ))}
                </Segmented>
            )}
        </VSpacingContainer>
    );
};

export default translation(NavRegions);
